import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DynamicRoutesService {

  urlApi = environment.urlApiVideos.url;
  headers: HttpHeaders
  basic: string

  constructor(private http: HttpClient) {
    this.createBtoaLogin();
  }

  createBtoaLogin(): void {
    this.basic = btoa(environment.urlApiVideos.user+':'+environment.urlApiVideos.password)
  }

  getPathPatterns(): Observable<object[]> {
    const path = '/api/Portal/PathPattern/GetPathPatterns';
    return this.http.get<{ PathPattern: object[] }>(this.urlApi + path, {
      headers: new HttpHeaders().set('Authorization', 'Basic ' + this.basic)
    }).pipe(
      map(response => response.PathPattern)
    );
  }

  getPathPatternSections(pathPatternId: number): Observable<{ PathPattern: object[] }> {
    const path = '/api/Portal/PathPattern/GetPathPatternSections?PathPatternId=';
    const url = `${this.urlApi + path}${pathPatternId}`;

    return this.http.get<{ PathPattern: object[] }>(url, {
      headers: new HttpHeaders().set('Authorization', 'Basic ' + this.basic)
    });

  }

  getPathPatternSectionsByPathPatternIdAndSectionId(pathPatternId: string,pathPatternSectionId:string): Observable<object> {
    const path = '/api/Portal/PathPattern/GetPathPatternSections?PathPatternId=';
    const url = `${this.urlApi + path}${pathPatternId}`;

    return this.http.get<{ PathPattern: object[] }>(url, {
      headers: new HttpHeaders().set('Authorization', 'Basic ' + this.basic)
    }).pipe(
      map(response => {
        const matchingObject = response.PathPattern.find(obj => {
          return obj['PathPatternSectionId'] == pathPatternSectionId
        });
        return matchingObject ? matchingObject : undefined;
      })
    );

  }

  getPathPatternSectionsByPathPatternId(pathPatternId: string): Observable<object[]> {
    const path = '/api/Portal/PathPattern/GetPathPatternSections?PathPatternId=';
    const url = `${this.urlApi + path}${pathPatternId}`;

    return this.http.get<{ PathPattern: object[] }>(url, {
      headers: new HttpHeaders().set('Authorization', 'Basic ' + this.basic)
    }).pipe(
      map(response => response.PathPattern)
    );

  }

  getPathPatternSectionTypes(): Observable<any> {
    const path = '/api/Portal/PathPattern/GetPathPatternSectionTypes';
    const url = this.urlApi + path;

    return this.http.get<{ PathPattern: object[] }>(url, {
      headers: new HttpHeaders().set('Authorization', 'Basic ' + this.basic)
    }).pipe(
      map(response => response.PathPattern.map((res:object)=>{
        return {
          Name: res['Name'],
          IdValue: res['IdValue']
        }
      }))
    );

  }

  getPathPatternFields(): Observable<object[]> {
    const path = '/api/Portal/PathPattern/GetPathPatternFields?PathPatternFieldId=';
    const url = this.urlApi + path;

    return this.http.get<{ PathPattern: object[] }>(url, {
      headers: new HttpHeaders().set('Authorization', 'Basic ' + this.basic)
    }).pipe(
      map(response => response.PathPattern)
    );

  }

  postUpdatePathPatternFields(pathPatternSectionId:String,pathPatternId:String,pathPatternSectionTypeId:String,allowEdit:string,patternSection:String){
    const path = `/api/Portal/PathPattern/UpdatePathPatternSections?PathPatternSectionId=${pathPatternSectionId}&PathPatternId=${pathPatternId}&PathPatternSectionTypeId=${pathPatternSectionTypeId}&AllowEdit=${allowEdit}&PatternSection=${patternSection}`;
    const url = this.urlApi + path;

    return this.http.post<{ PathPattern: object[] }>(url, {}, {
      headers: new HttpHeaders().set('Authorization', 'Basic ' + this.basic)
    }).pipe(
      map(response => response.PathPattern)
    );

  }

}
